export function OperatorHistoryControls({ loading, loaded, error, count, hasMore, onRefresh, onRetry, onMore }: {
  loading: boolean; loaded: boolean; error: string | null; count: number; hasMore: boolean;
  onRefresh: () => void; onRetry: () => void; onMore: () => void;
}) {
  return <div className="operator-history-controls">
    <div className="operator-history-status" role="status" aria-live="polite">
      {loading ? "Kayıtlar yükleniyor…" : loaded ? `${count} kayıt gösteriliyor${hasMore ? "; daha eski kayıtlar var" : ""}.` : null}
    </div>
    {error ? <div className="operator-completed-error" role="alert"><p>{error}</p><button type="button" onClick={onRetry} disabled={loading}>Yeniden dene</button></div> : null}
    <div className="operator-history-actions">
      <button type="button" disabled={loading} onClick={onRefresh}>Geçmişi yenile</button>
      {hasMore ? <button type="button" disabled={loading} onClick={onMore}>Daha eski kayıtları getir</button> : null}
    </div>
  </div>;
}
